
import { UserSelectionListComponentName } from "../../components/common/selection/UserSelectionList"
import { AlertListComponetName } from "./alertActions";
import { AlertListTenantAdminComponetName } from "./alertActions";
import { UserListComponetName } from "./userManagerActions";
import { UserListTenantAdminComponetName } from "../../components/tenantAdmin/UserList"
import { EmailListComponentName } from "../../components/controlPanel/EmailList"
import { HealthCheckListComponentName } from "../../components/controlPanel/HealthCheckList"
import { EmailListTenantAdminComponentName } from "../../components/tenantAdmin/EmailList"
import { PhoneListComponentName } from "../../components/controlPanel/PhoneList"
import { PhoneListTenantAdminComponentName } from "../../components/tenantAdmin/PhoneList"
import { PhoneSelectionListComponentName } from "../../components/common/selection/PhoneNumberSelectionList"
import { EmailAddressSelectionListComponentName } from "../../components/common/selection/EmailAddressSelectionList"
import { AdminListTenantAdminKey, FileUploadsTenantAdminKey } from "./tenantAdminActions";

export const setSelectedPaginationPage = (listType, pageNumber) => {

  let actionType = '';

  switch (listType) {

    case AlertListComponetName: // Control Panel Alert List
      actionType = 'SET_SELECTED_ALERTS_PAGE'
      break;

    case AlertListTenantAdminComponetName: // Tenant Admin Alert List
      actionType = 'SET_SELECTED_ALERTS_TENANT_ADMIN_PAGE'
      break;

    case AdminListTenantAdminKey: // Tenant Admin Administrators
      actionType = 'SET_SELECTED_ADMINISTRATORS_TENANT_ADMIN_PAGE'
      break;

    case FileUploadsTenantAdminKey: // Tenant Admin File Uploads
      actionType = 'SET_SELECTED_FILE_UPLOADS_TENANT_ADMIN_PAGE'
      break;

    case UserListComponetName: // Control Panel User Manager
      actionType = 'SET_SELECTED_USERS_PAGE'
      break;

    case UserListTenantAdminComponetName: // Tenant Admin User List
      actionType = 'SET_SELECTED_USERS_TENANT_ADMIN_PAGE'
      break;
    
    case PhoneListComponentName: // Control Panel Phone List
      actionType = 'SET_SELECTED_PHONES_PAGE'
      break;

    case PhoneListTenantAdminComponentName: // Tenant Admin Phone List
      actionType = 'SET_SELECTED_PHONES_TENANT_ADMIN_PAGE'
      break;

    case EmailListComponentName: // Control Panel Email List
      actionType = 'SET_SELECTED_EMAIL_ADDRESSES_PAGE'
      break;

    case EmailListTenantAdminComponentName: // TenantAdmin Email List
      actionType = 'SET_SELECTED_EMAIL_ADDRESSES_TENANT_ADMIN_PAGE'
      break;

    case HealthCheckListComponentName: // Control Panel Health Check List
      actionType = 'SET_SELECTED_HEALTH_CHECKS_PAGE'
      break;

    case UserSelectionListComponentName: // User Selection Popup
      actionType = 'SET_SELECTED_USER_SELECTION_PAGE'
      break;

    case PhoneSelectionListComponentName: // Phone Selection List
      actionType = 'SET_SELECTED_PHONE_SELECTION_PAGE'
      break;

    case EmailAddressSelectionListComponentName: // Email Selection List
      actionType = 'SET_SELECTED_EMAIL_ADDRESS_SELECTION_PAGE'
      break;

    default:
      break;
  }

  return {
    type: actionType,
    pageNumber
  }
}

